module.exports = __webpack_public_path__ + "img/joy_sp_04.3d6a0326.png";